import { Box, Container, Heading, Text, SimpleGrid, Icon, VStack, Button, HStack } from '@chakra-ui/react';
import { FaYoutube, FaClipboardCheck, FaUserGraduate, FaRobot, FaWhatsapp } from 'react-icons/fa';
import { Link as RouterLink } from 'react-router-dom';
import CountdownTimer from '../components/CountdownTimer';

const FeatureCard = ({ icon, title, description }) => (
  <VStack
    p={6}
    bg="white"
    rounded="xl"
    shadow="md"
    spacing={4}
    align="start"
    _hover={{ transform: 'translateY(-5px)', transition: 'all 0.2s' }}
  >
    <Icon as={icon} boxSize={10} color="blue.500" />
    <Heading size="md">{title}</Heading>
    <Text color="gray.600">{description}</Text>
  </VStack>
);

const Home = () => {
  const features = [
    {
      icon: FaYoutube,
      title: 'Streaming en Vivo',
      description: 'Clases virtuales en tiempo real a través de YouTube'
    },
    {
      icon: FaClipboardCheck,
      title: 'Evaluación Continua',
      description: 'Formularios de evaluación para cada encuentro'
    },
    {
      icon: FaUserGraduate,
      title: 'Aprendizaje Práctico',
      description: 'Contenido enfocado en aplicaciones reales de IA'
    },
    {
      icon: FaRobot,
      title: 'Tecnología Actual',
      description: 'Exploración de las últimas tendencias en IA'
    }
  ];

  return (
    <Box bg="gray.50" minH="calc(100vh - 64px)">
      <Container maxW="container.xl" py={{ base: 10, md: 20 }}>
        <VStack spacing={{ base: 6, md: 8 }} textAlign="center" mb={{ base: 12, md: 16 }}>
          <Heading
            size={{ base: "xl", md: "2xl" }}
            bgGradient="linear(to-r, blue.400, blue.600)"
            bgClip="text"
            lineHeight="1.2"
            pb={2}
            px={{ base: 2, md: 8 }}
            maxW={{ base: "100%", md: "container.xl" }}
            mx="auto"
            textAlign="center"
            whiteSpace="normal"
            overflow="visible"
            mb={4}
          >
            Inteligencia Artificial en Educación
          </Heading>
          <Text fontSize={{ base: "lg", md: "xl" }} color="gray.600" maxW="container.md" px={8}>
           Esta capacitación ha finalizado, pero el contenido de la misma es de acceso público.
          </Text>
          <VStack spacing={6} w={{ base: "full", md: "container.md" }} mx="auto" align="stretch">
            <VStack spacing={4} w="full">
              {[1, 2, 3, 4].map((num) => (
                <Button
                  key={num}
                  as={RouterLink}
                  to={`/session/${num}`}
                  size="lg"
                  colorScheme="blue"
                  w={{ base: "full", md: "container.md" }}
                  mx="auto"
                >
                  {`${num}° Encuentro - Ver / Asistencia`}
                </Button>
              ))}
              <Button
                as={RouterLink}
                to="/session/6"
                size="lg"
                colorScheme="blue"
                w={{ base: "full", md: "container.md" }}
                mx="auto"
              >
                Evaluación Final
              </Button>
              <Button
                as={RouterLink}
                to="/session/5"
                size="lg"
                colorScheme="blue"
                w={{ base: "full", md: "container.md" }}
                mx="auto"
              >
                Clase de Apoyo
              </Button>
              <Button
                as={RouterLink}
                to="/session/7"
                size="lg"
                colorScheme="blue"
                w={{ base: "full", md: "container.md" }}
                mx="auto"
              >
                Tutorial Rosarito
              </Button>
            </VStack>
            
            <Button
                as="a"
                href="https://castrobarros.edu.ar/ia/resultado2/webresultados.html"
                target="_blank"
                size="lg"
                colorScheme="blue"
                variant="outline"
                w={{ base: "full", md: "container.md" }}
                mx="auto"
              >
                Verificar Resultados de Participación
              </Button>

              <Button
                as="a"
                href="https://castrobarros.edu.ar/ia/recuperatorio.html"
                target="_blank"
                size="lg"
                colorScheme="blue"
                variant="outline"
                w={{ base: "full", md: "container.md" }}
                mx="auto"
              >
                Recuperatorio 
              </Button>
            <VStack spacing={4} pt={4}>
              <Button
                as={RouterLink}
                to="/session/8"
                size="lg"
                colorScheme="purple"
                variant="solid"
                w={{ base: "full", md: "container.md" }}
                mx="auto"
                _hover={{ transform: 'scale(1.05)', transition: 'all 0.2s' }}
              >
                Recursos
              </Button>

              <Button
                as="a"
                href="https://castrobarros.edu.ar/ia/recibos/"
                target="_blank"
                size="lg"
                colorScheme="blue"
                variant="outline"
                w={{ base: "full", md: "container.md" }}
                mx="auto"
              >
                Descargar constancia de pago
              </Button>

              <Button
                as="a"
                href="https://castrobarros.edu.ar/ia/certificados/"
                target="_blank"
                size="lg"
                colorScheme="blue"
                variant="outline"
                w={{ base: "full", md: "container.md" }}
                mx="auto"
              >
                DESCARGAR CERTIFICADO DE PARTICIPACIÓN
              </Button>

              <Button
                as="a"
                href="https://castrobarros.edu.ar/ia/rendicion.html"
                target="_blank"
                size="lg"
                colorScheme="blue"
                variant="outline"
                w={{ base: "full", md: "container.md" }}
                mx="auto"
              >
                Rendición de recursos generados
              </Button>

              <Button
                as="a"
                href="https://whatsapp.com/channel/0029Vaksi57BFLgZAPmiLQ1S"
                target="_blank"
                leftIcon={<FaWhatsapp />}
                bg="#25D366"
                color="white"
                _hover={{ bg: "#1ebe5d" }}
                _active={{ bg: "#1aa653" }}
                size="lg"
                w={{ base: "full", md: "container.md" }}
                mx="auto"
              >
                Unirse al Canal
              </Button>
            </VStack>
          </VStack>
        </VStack>

        <Box mb={12} px={{ base: 4, md: 0 }}>
          <CountdownTimer />
        </Box>
        
        <Box as="footer" mt={12} textAlign="center">
          <Button
            as="a"
            href="/resolucion-ministerial.pdf"
            download
            size="md"
            colorScheme="blue"
            variant="outline"
            w={{ base: "full", sm: "auto" }}
          >
            Descargar Resolución Ministerial
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default Home;